import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import { addTeacherToClassroom, removeTeacherFromClassroom } from "@/api/modifyTeachers";
import { makeClassroomDetailsInvalidationKey } from "@/query/classroomDetailsQuery";

type TeacherMutationOptions = {
	onSuccess?: () => void;
	onError?: (error: Error) => void;
};

export function useAddTeacherToClassroomMutation(
	classroomId: string,
	classroomStableIdV1: string,
	options?: TeacherMutationOptions
): UseMutationResult<void, Error, string> {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (teacherQoriaUserId: string) => addTeacherToClassroom(teacherQoriaUserId, classroomStableIdV1),
		onSuccess: () => {
			options?.onSuccess?.();
		},
		onError: (error) => {
			options?.onError?.(error);
		},
		onSettled: () => {
			void queryClient.invalidateQueries({ queryKey: makeClassroomDetailsInvalidationKey(classroomId) });
		},
	});
}

export function useRemoveTeacherFromClassroomMutation(
	classroomId: string,
	classroomStableIdV1: string,
	options?: TeacherMutationOptions
): UseMutationResult<void, Error, string> {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (teacherQoriaUserId: string) => removeTeacherFromClassroom(teacherQoriaUserId, classroomStableIdV1),
		onSuccess: () => {
			options?.onSuccess?.();
		},
		onError: (error) => {
			options?.onError?.(error);
		},
		onSettled: () => {
			void queryClient.invalidateQueries({ queryKey: makeClassroomDetailsInvalidationKey(classroomId) });
		},
	});
}
